(function () {
	'use strict';
	$(document).ready(function () {

		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top
				}, 1000);
			}
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Search trigger
		$('.search-trigger').click(function () {
			$(this).toggleClass('active');
			$('.search-panel').fadeToggle('active');
			return false;
		});

		//newsletter
		function sendNewsletter(email) {
			const button = $('.button-newsletter');
			$.ajax({
				type: "GET",
				url: fh_config.rest_url + "fh/v1/send-newsletter",
				data: {
					'email': email,
				},
				headers: {
					'X-WP-Nonce': fh_config.rest_nonce,
				},
				beforeSend: function () {
					button.attr("disabled", true);
				},
				success: function () {
					button.attr("disabled", false);
					button.text(fhTranslate('wyslano'));
				},
				error: function (response) {
					button.attr("disabled", false);
					console.log(response)
				}
			});
		}


		document.querySelector('.button-newsletter').addEventListener('click', (e) => {
			e.preventDefault();
			const input = document.querySelector('.newsletter-email');
			input.classList.remove('error');
			if (input.value !== '') {
				sendNewsletter(input.value);
			} else {
				input.classList.add('error');
			}
		})


		const languageSwitcher = document.querySelector(".lang-item-current button");
		languageSwitcher.addEventListener("click", function () {
			languageSwitcher.nextElementSibling.classList.toggle("open");
		});

		clickedOutside('.sub-lang', function () {
			languageSwitcher.nextElementSibling.classList.remove("open")
		}, ['.language-switcher']);


		const isOverflowing = (element, container = document.body) => {
			const containerRect = container.getBoundingClientRect();
			const containerTop = containerRect.top + window.scrollY;
			const elementRect = element.getBoundingClientRect();
			const elementTop = elementRect.top + window.scrollY;

			if (containerTop + containerRect.height < elementTop + elementRect.height) {
				return 'bottom'
			}

			if (containerTop > elementTop || elementRect.y <= 0) {
				return 'top';
			}

			return null;
		}

		// Previous reports dropdown logic
		const previousReportsTrigger = document.querySelectorAll('.previous-reports-trigger');
		previousReportsTrigger.forEach((triggerButton) => {
			const container = triggerButton.closest('.previous-reports');
			const list = triggerButton.parentElement.querySelector('ul.previous-reports-list');
			const handleOverflowing = () => {
				const overflowing = isOverflowing(list);
				if (overflowing === 'top') {
					container.classList.remove('side-top');
					container.classList.add('side-bottom');
				} else if (overflowing === 'bottom') {
					container.classList.add('side-top');
					container.classList.remove('side-bottom');
				}
			}
			handleOverflowing();
			triggerButton.addEventListener('click', () => {
				handleOverflowing();
				const willClose = triggerButton.classList.contains('open');
				triggerButton.setAttribute('aria-expanded', willClose ? 'false' : 'true')
				triggerButton.classList.toggle('open', !willClose);
				list.classList.toggle('open', !willClose);
			})

			clickedOutside('ul.previous-reports-list', function () {
				triggerButton.classList.remove('open');
				list.classList.remove('open');
			}, ['.previous-reports-trigger']);
		})
	});
}(jQuery));
